import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';

export default function SubscriberCounter() {
  const [count, setCount] = useState(5247); // Starting count
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSubscriberCount();
  }, []);

  const fetchSubscriberCount = async () => {
    try {
      const { count: realCount, error } = await supabase
        .from('newsletter_subscribers')
        .select('*', { count: 'exact', head: true });

      if (!error && realCount !== null) {
        // Add base number to make it look more impressive
        setCount(5000 + realCount);
      }
    } catch (error) {
      console.error('Error fetching subscriber count:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="inline-flex items-center space-x-2 text-sm text-gray-600">
      <div className="flex -space-x-2">
        <div className="w-8 h-8 rounded-full bg-teal-200 border-2 border-white flex items-center justify-center">
          <i className="ri-user-line text-teal-700 text-xs"></i>
        </div>
        <div className="w-8 h-8 rounded-full bg-orange-200 border-2 border-white flex items-center justify-center">
          <i className="ri-user-line text-orange-700 text-xs"></i>
        </div>
        <div className="w-8 h-8 rounded-full bg-purple-200 border-2 border-white flex items-center justify-center">
          <i className="ri-user-line text-purple-700 text-xs"></i>
        </div>
      </div>
      <span>
        {isLoading ? (
          'Loading...'
        ) : (
          <>
            <strong className="font-semibold text-gray-900">{count.toLocaleString()}+</strong> Americans already subscribed
          </>
        )}
      </span>
    </div>
  );
}